(function () {
  const storageKey = 'NuaGiftRegistryReturnUrl';
  const returnContainers = document.querySelectorAll('[data-gift-registry-return]');

  if (!returnContainers.length) return;

  let returnPath = '';

  try {
    const storedValue = sessionStorage.getItem(storageKey);

    if (storedValue) {
      const returnUrl = new URL(storedValue, window.location.origin);
      const isSameOrigin = returnUrl.origin === window.location.origin;
      const isRegistryPath = /^\/apps\/giftregistry\/registry\/\d+\/?$/.test(returnUrl.pathname);

      if (isSameOrigin && isRegistryPath) {
        returnPath = returnUrl.pathname;
      } else {
        sessionStorage.removeItem(storageKey);
      }
    }
  } catch (error) {
    returnPath = '';
  }

  if (!returnPath || window.location.pathname === returnPath) return;

  returnContainers.forEach(function (container) {
    const returnLink = container.querySelector('[data-gift-registry-return-link]');

    if (!returnLink) return;

    returnLink.href = returnPath;
    container.hidden = false;
  });
})();
